'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function SubLineComponent($q, $http, AppConstants) {
	'ngInject';

	var service = {
		'fetchSubLines': fetchSubLines,
		'searchSubLines': searchSubLines,
		'fetchSubLine': fetchSubLine,
		'getGoingSubLines': getGoingSubLines,
		'getReturnSubLines': getReturnSubLines,
		'getSubLine': getSubLine,
		'getSubLines': getSubLines,
		'failedRequest': failedRequest,
		'clearGoingSubLines': clearGoingSubLines,
		'clearReturnSubLines': clearReturnSubLines,
		'getPaginationInfo': getPaginationInfo,
		'getGoingPaginationInfo': getGoingPaginationInfo,
		'getReturnPaginationInfo': getReturnPaginationInfo
	};

	var paginationInfo = {};
	var subLines = [];
	var goingPaginationInfo = {};
	var returnPaginationInfo = {};
	var goingSubLines = [];
	var returnSubLines = [];
	var subLine = {};

	return service;

	function fetchSubLines(searchParams) {
		var page = arguments.length <= 1 || arguments[1] === undefined ? 1 : arguments[1];
		var promotionId = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];

		searchParams.page = page;
		searchParams.per_page = AppConstants.perPage;
		searchParams['with'] = 'line,line.translation';

		if (promotionId) {
			searchParams.without_promotion = promotionId;
		}

		return $http.get(AppConstants.apiUrl + '/sub-lines', {
			'params': searchParams
		}).then(setSubLines)['catch'](failedRequest);
	}

	function searchSubLines(searchParams, direction) {
		var page = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
		var promotionId = arguments.length <= 3 || arguments[3] === undefined ? 0 : arguments[3];

		searchParams.page = page;
		searchParams.per_page = 1000;
		searchParams.is_public = searchParams.is_public ? 1 : 0;

		if (promotionId) {
			searchParams.without_promotion = promotionId;
		}

		return $http.get(AppConstants.apiUrl + '/sub-lines/search', {
			'params': searchParams
		}).then(function (res) {
			if (direction === 'return') {
				return setReturnSubLines(res);
			} else {
				return setGoingSubLines(res);
			}
		})['catch'](failedRequest);
	}

	function fetchSubLine(subLineId, busId, date, isPublic) {
		var getParams = {
			'date': date,
			'bus_id': busId,
			'is_public': isPublic ? 1 : 0
		};

		return $http.get(AppConstants.apiUrl + '/sub-lines/' + subLineId, {
			'params': getParams
		}).then(setSubLine)['catch'](failedRequest);
	}

	function setGoingSubLines(response) {
		goingPaginationInfo.page_size = AppConstants.perPage;
		goingPaginationInfo.page = response.data.current_page;
		goingPaginationInfo.total = response.data.total;
		goingPaginationInfo.type = response.data.type;
		goingSubLines = response.data.data;

		return goingSubLines;
	}

	function setReturnSubLines(response) {
		returnPaginationInfo.page_size = AppConstants.perPage;
		returnPaginationInfo.page = response.data.current_page;
		returnPaginationInfo.total = response.data.total;
		returnPaginationInfo.type = response.data.type;
		returnSubLines = response.data.data;

		return returnSubLines;
	}

	function setSubLines(response) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = response.data.current_page;
		paginationInfo.total = response.data.total;
		subLines = response.data.data;

		return subLines;
	}

	function setSubLine(response) {
		subLine = response.data.data;

		return subLine;
	}

	function getGoingSubLines() {
		return goingSubLines;
	}

	function getReturnSubLines() {
		return returnSubLines;
	}

	function getSubLines() {
		return subLines;
	}

	function getSubLine() {
		return subLine;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function getGoingPaginationInfo() {
		return goingPaginationInfo;
	}

	function getReturnPaginationInfo() {
		return returnPaginationInfo;
	}

	function clearGoingSubLines() {
		goingSubLines = [];
		goingPaginationInfo = {};
	}

	function clearReturnSubLines() {
		returnSubLines = [];
		returnPaginationInfo = {};
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}
exports['default'] = SubLineComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/sub-line/sub-line.service.js
 **/